import { jsx as _jsx } from "react/jsx-runtime";
import { Table as MuiTable, TableBody as MuiTableBody, TableCell as MuiTableCell, TableHead as MuiTableHead, TableRow as MuiTableRow, } from "@mui/material";
export function Table({ sx = [], ...props }) {
    return (_jsx(MuiTable, { component: "div", sx: [
            {
                height: "100%",
                "> .MuiTableBody-root > .MuiTableRow-root:last-child > .MuiTableCell-root": {
                    borderBottom: "none",
                },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...props }));
}
export function TableHead(props) {
    return _jsx(MuiTableHead, { component: "div", ...props });
}
export function TableBody(props) {
    return _jsx(MuiTableBody, { component: "div", ...props });
}
export function TableRow({ sx = [], ...props }) {
    return (_jsx(MuiTableRow, { component: "div", sx: [
            {
                cursor: "default",
                textDecoration: "none",
                "&[href]:hover, &[tabindex]:hover": {
                    cursor: "pointer",
                    backgroundColor: ({ palette }) => palette.action.hover,
                },
                "&[href]:focus, &[tabindex]:focus, &.Mui-selected": {
                    backgroundColor: ({ palette }) => palette.action.focus,
                },
            },
            ...(Array.isArray(sx) ? sx : [sx]),
        ], ...props }));
}
export const TableCell = ({ sx = [], nowrap, noWidth, ...props }) => (_jsx(MuiTableCell, { component: "div", align: "center", sx: [
        { height: "100%" },
        nowrap ? { whiteSpace: "nowrap" } : {},
        noWidth ? { width: 0 } : {},
        !props.padding
            ? {
                padding: ({ spacing }) => `${spacing(0.5)} ${spacing(1.5)}`,
            }
            : {},
        ...(Array.isArray(sx) ? sx : [sx]),
    ], ...props }));
//# sourceMappingURL=Table.js.map